var _circle, _path, _circle2, _circle3, _circle4, _circle5, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrgExists = function SvgOrgExists(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 208,
    viewBox: "0 0 214 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.17,
    cx: 108.837,
    cy: 103,
    r: 102.163,
    fill: "#C5CEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.336 142.581C130.181 148.894 119.948 152.651 108.837 152.651C82.1989 152.651 60.6045 131.057 60.6045 104.419C60.6045 93.3136 64.3575 83.085 70.6645 74.9322C70.6499 74.9155 70.6354 74.8986 70.621 74.8815C69.4311 73.4661 69.614 71.354 71.0294 70.1641L81.7943 61.1146C83.2098 59.9247 85.3218 60.1076 86.5117 61.523C86.537 61.5531 86.5617 61.5836 86.5858 61.6143C93.2432 58.1464 100.811 56.1862 108.837 56.1862C135.475 56.1862 157.07 77.7806 157.07 104.419C157.07 113.57 154.521 122.127 150.094 129.417C151.256 130.631 151.346 132.55 150.245 133.871L143.223 142.304C142.04 143.725 139.929 143.918 138.508 142.734C138.448 142.685 138.391 142.634 138.336 142.581Z",
    fill: "url(#paint0_radial_2426_2565)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.19,
    cx: 106,
    cy: 74.6281,
    r: 7.09302,
    fill: "#C5CEFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.19,
    cx: 76.2089,
    cy: 100.163,
    r: 4.25581,
    fill: "#C5CEFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.19,
    cx: 98.9072,
    cy: 135.628,
    r: 4.25581,
    fill: "#C5CEFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.19,
    cx: 120.896,
    cy: 105.128,
    r: 9.22093,
    fill: "#C5CEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.055 82.9776C150.932 83.9617 149.46 84.5582 147.85 84.5582C144.324 84.5582 141.466 81.7001 141.466 78.1745C141.466 75.6828 142.893 73.5245 144.975 72.4729C147.771 75.6326 150.158 79.1617 152.055 82.9776Z",
    fill: "#C5CEFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.512,
    y: 34.907,
    width: 15.6047,
    height: 11.3488,
    rx: 1.4186,
    fill: "#BBC6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.837,
    y: 32.0698,
    width: 14.186,
    height: 11.3488,
    rx: 1.4186,
    fill: "#C5CEFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.418,
    y: 27.814,
    width: 2.83721,
    height: 29.7907,
    rx: 1.4186,
    fill: "#8C9EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.506 182.892C13.0068 181.773 14.5947 181.773 15.0955 182.892L16.7418 186.569C17.5963 188.478 19.1236 190.005 21.0323 190.859L24.7093 192.506C25.8279 193.007 25.8279 194.594 24.7093 195.095L21.0323 196.742C19.1236 197.596 17.5963 199.123 16.7418 201.032L15.0955 204.709C14.5947 205.828 13.0068 205.828 12.506 204.709L10.8597 201.032C10.0052 199.123 8.47794 197.596 6.56929 196.742L2.89224 195.095C1.77368 194.594 1.77368 193.007 2.89224 192.506L6.56929 190.859C8.47794 190.005 10.0052 188.478 10.8597 186.569L12.506 182.892Z",
    fill: "#C5CEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M197.301 5.33806C197.533 4.82052 198.268 4.82052 198.499 5.33806C199.488 7.54585 201.255 9.31248 203.462 10.3009C203.98 10.5327 203.98 11.2674 203.462 11.4991C201.255 12.4875 199.488 14.2542 198.499 16.462C198.268 16.9795 197.533 16.9795 197.301 16.462C196.313 14.2542 194.546 12.4875 192.338 11.4991C191.821 11.2674 191.821 10.5327 192.338 10.3009C194.546 9.31248 196.313 7.54585 197.301 5.33806Z",
    fill: "#C5CEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M208.875 21.0895C209.132 20.5152 209.948 20.5152 210.205 21.0895C210.644 22.0696 211.428 22.8538 212.408 23.2926C212.982 23.5497 212.982 24.3651 212.408 24.6222C211.428 25.061 210.644 25.8452 210.205 26.8253C209.948 27.3996 209.132 27.3996 208.875 26.8253C208.436 25.8452 207.652 25.061 206.672 24.6222C206.098 24.3651 206.098 23.5497 206.672 23.2926C207.652 22.8538 208.436 22.0696 208.875 21.0895Z",
    fill: "#C5CEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.543 139.884L180.083 141.09C180.255 141.475 180.564 141.783 180.949 141.956L182.155 142.495L180.949 143.035C180.564 143.208 180.255 143.516 180.083 143.901L179.543 145.107L179.003 143.901C178.831 143.516 178.522 143.208 178.137 143.035L176.931 142.495L178.137 141.956C178.522 141.783 178.831 141.475 179.003 141.09L179.543 139.884Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.846 165.194L157.859 167.458C158.031 167.843 158.34 168.151 158.725 168.323L160.988 169.337L158.725 170.35C158.34 170.522 158.031 170.831 157.859 171.216L156.846 173.479L155.832 171.216C155.66 170.831 155.352 170.522 154.967 170.35L152.703 169.337L154.967 168.323C155.352 168.151 155.66 167.843 155.832 167.458L156.846 165.194Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8164 37.7443L55.8297 40.0075C56.0021 40.3927 56.3104 40.7009 56.6956 40.8734L58.9588 41.8867L56.6956 42.8999C56.3104 43.0724 56.0021 43.3806 55.8297 43.7658L54.8164 46.029L53.8031 43.7659C53.6307 43.3806 53.3224 43.0724 52.9372 42.8999L50.674 41.8867L52.9372 40.8734C53.3224 40.7009 53.6307 40.3927 53.8031 40.0075L54.8164 37.7443Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.91 66.1163L184.923 68.3795C185.096 68.7647 185.404 69.073 185.789 69.2455L188.053 70.2587L185.789 71.272C185.404 71.4445 185.096 71.7527 184.923 72.1379L183.91 74.4011L182.897 72.1379C182.724 71.7527 182.416 71.4445 182.031 71.272L179.768 70.2587L182.031 69.2455C182.416 69.073 182.724 68.7647 182.897 68.3795L183.91 66.1163Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7314 54.5973L51.4393 56.1784C51.5598 56.4476 51.7752 56.6629 52.0443 56.7834L53.6255 57.4913L52.0443 58.1992C51.7752 58.3197 51.5598 58.535 51.4393 58.8042L50.7314 60.3853L50.0235 58.8042C49.9031 58.535 49.6877 58.3197 49.4186 58.1992L47.8374 57.4913L49.4186 56.7834C49.6877 56.6629 49.9031 56.4476 50.0235 56.1784L50.7314 54.5973Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0625 105.837L29.1243 108.209C29.3051 108.613 29.6281 108.936 30.0318 109.116L32.4035 110.178L30.0318 111.24C29.6281 111.421 29.3051 111.744 29.1244 112.148L28.0625 114.519L27.0006 112.148C26.8199 111.744 26.4969 111.421 26.0932 111.24L23.7215 110.178L26.0932 109.116C26.4969 108.936 26.8199 108.613 27.0007 108.209L28.0625 105.837Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6904 165.419L61.7523 167.79C61.933 168.194 62.256 168.517 62.6597 168.698L65.0314 169.76L62.6597 170.822C62.256 171.002 61.933 171.325 61.7523 171.729L60.6904 174.101L59.6286 171.729C59.4478 171.325 59.1248 171.002 58.7211 170.822L56.3494 169.76L58.7211 168.698C59.1248 168.517 59.4478 168.194 59.6286 167.79L60.6904 165.419Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2426_2565",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.558 149.105) rotate(165.964) scale(78.9623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrgExists);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "org-exists.1f4c7bc38e5d8c407a2c34fd5114808e.svg";